import { render, staticRenderFns } from "./EditMessage.vue?vue&type=template&id=dc453ee2&scoped=true&"
import script from "./EditMessage.vue?vue&type=script&lang=js&"
export * from "./EditMessage.vue?vue&type=script&lang=js&"
import style0 from "./EditMessage.vue?vue&type=style&index=0&id=dc453ee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc453ee2",
  null
  
)

export default component.exports